import { render, staticRenderFns } from "./DeleteShipmentsModal.vue?vue&type=template&id=6d878cde&"
import script from "./DeleteShipmentsModal.vue?vue&type=script&lang=js&"
export * from "./DeleteShipmentsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports